var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBowl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M20.802 12.983l-.01.015-.007.017-1.706 3.523c-1.01 1.822-2.968 2.962-5.12 2.962h-3.92c-2.153 0-4.112-1.141-5.122-2.966l-.014-.03L3.2 12.988h0l-.005-.008-.008-.018a.15.15 0 01-.003-.005l-.004-.01-.005-.01-.185-.382h.002l-.214-.444-1.153-2.387c-.297-.754-.041-1.634.485-2.007h0l.007-.005 4.096-3.003a1.08 1.08 0 01.628-.208h10.318c.214 0 .426.067.616.2l4.12 3.02h0l.007.004c.514.364.772 1.249.47 2.006l-.017.037-1.52 3.145-.006.011-.005.012a.428.428 0 01-.022.048z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M2 11c3.519 1.154 6.255 2 10 2s6.481-.846 10-2"
  }));
}
export default SvgIconBowl;